import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Twitter, Linkedin } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img src="/ascarii-logo.png" srcSet="/ascarii-logo.png 1x, /ascarii-logo@2x.png 2x" alt="Ascarii" className="h-8 w-auto" />
            </div>
            <p className="text-gray-400 mb-6">
              SAP Premier Partner specialising in cloud-first ERP solutions for SMEs worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="https://linkedin.com/company/ascarii" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-blue-400 transition-colors">About Us</Link></li>
              <li><Link to="/experience" className="text-gray-400 hover:text-blue-400 transition-colors">Ascarii Experience</Link></li>
              <li><Link to="/services/implementation" className="text-gray-400 hover:text-blue-400 transition-colors">Implementation</Link></li>
              <li><Link to="/services/support" className="text-gray-400 hover:text-blue-400 transition-colors">Support</Link></li>
              <li><Link to="/cloud-hosting" className="text-gray-400 hover:text-blue-400 transition-colors">Cloud Hosting</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-blue-400 transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-lg font-bold mb-6">Solutions</h3>
            <ul className="space-y-3">
              <li><Link to="/sap-business-one/industries/manufacturing" className="text-gray-400 hover:text-blue-400 transition-colors">Manufacturing</Link></li>
              <li><Link to="/sap-business-one/industries/wholesale" className="text-gray-400 hover:text-blue-400 transition-colors">Wholesale Distribution</Link></li>
              <li><Link to="/sap-business-one/industries/professional-services" className="text-gray-400 hover:text-blue-400 transition-colors">Professional Services</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <p className="text-gray-400 text-sm">
                  NETPark Thomas, Wright Way<br />
                  Sedgefield, County Durham<br />
                  TS21 3FD
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href="tel:+441789777466" className="text-gray-400 hover:text-blue-400 transition-colors">
                  +44 (0)1789 777 466
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a href="mailto:info@ascarii.com" className="text-gray-400 hover:text-blue-400 transition-colors">
                  info@ascarii.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Partner Logos */}
        <div className="border-t border-gray-800 pt-12 mb-12">
          <h3 className="text-center text-lg font-bold mb-8">Our Partners</h3>
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="bg-white rounded-lg px-6 py-3">
              <span className="text-gray-900 font-bold">SAP Premier Partner</span>
            </div>
            <div className="bg-white rounded-lg px-6 py-3">
              <span className="text-gray-900 font-bold">AWS Advanced Partner</span>
            </div>
            <div className="bg-white rounded-lg px-6 py-3">
              <span className="text-gray-900 font-bold">Boyum Gold Partner</span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <p className="text-gray-400">
              © {currentYear} Ascarii. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/terms" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Terms & Conditions</Link>
              <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;